import {
    Component,
    Input,
    ChangeDetectionStrategy,
    Output,
    EventEmitter,
    OnInit,
    OnChanges,
    SimpleChanges
} from '@angular/core';
import { ProcessingStatus } from 'app_sasha/shared/resources/processings/ProcessingStatus';
import { PROCESSING_STATUSES } from 'app_sasha/shared/wordings/processing';
import { ILabels } from "libraries/interfaces/ILabels";
import { Yii } from "libraries/interfaces/Yii";
import { faCheck, faCogs, faExclamation, faHourglassEnd, faTimes, IconDefinition } from "@fortawesome/free-solid-svg-icons";

export const ICONS: { [key: string]: IconDefinition } = {
    [ProcessingStatus.Pending]: faHourglassEnd,
    [ProcessingStatus.Error]: faTimes,
    [ProcessingStatus.Warning]: faExclamation,
    [ProcessingStatus.Success]: faCheck,
    [ProcessingStatus.Processing]: faCogs,
};

@Component({
    selector: 'processing-status',
    template: `
        <div class="status-container"
             [ngClass]="class"
             [class.hasTotal]="total !== null && total !== undefined"
             [class.clickable]="select"
             [title]="statuses[name] + clickToFilterLabel"
             (click)="onClick(name)"
             [ngStyle]="{'cursor':cursorStyle}">
            <div class="icon-container">
                <fa-icon [icon]="icons[name]"></fa-icon>
            </div>
            <div class="nb-status">
                {{count || 0}}
                <ng-container *ngIf="total !== null && total !== undefined">
                    / {{ total }}
                </ng-container>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./processing-status.component.scss']
})
export class ProcessingStatusComponent implements OnInit, OnChanges {
    @Input()
    public name: string;

    @Input()
    public count: number;

    @Input()
    public total: number;

    /** Indicates if component is clickable. */
    @Input()
    public select: boolean = false;

    @Input()
    public statusSelected: boolean = false;
    @Input()
    public selectedStatus: string;

    @Output()
    public readonly onSelect: EventEmitter<string> = new EventEmitter();

    public readonly icons: { [processingStatus: string]: IconDefinition } = ICONS;

    public readonly statuses: ILabels = PROCESSING_STATUSES;

    public clickToFilterLabel: string = '';

    public cursorStyle: string = 'default';

    public class: string[] = [];

    public onClick(name: string): void {
        if (this.select) {
            this.onSelect.emit(name);
        }
    }

    public ngOnInit(): void {
        this.onInit();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        this.onInit();
    }

    private onInit(): void {
        this.class = [this.name];
        if (this.select) {
            this.cursorStyle = 'pointer';
            if (this.statusSelected && !this.selectedStatus) {
                this.class.push('selected');
            }else if(this.selectedStatus === this.name) {
                this.class.push('selected');
            }
            this.clickToFilterLabel = `\n${Yii.t('wui-shared-js', 'Cliquez pour afficher uniquement les dossiers correspondants.')}`;
        }
    }
}
